import { getSupportedFallbackForLocale } from 'owa-strings';
import store from 'owa-strings/store/store';

const OWA_LOCALE_TO_ITEMSVIEW_LOCALE_MAP = {
    am: 'am-et',
    'be-by': 'be',
    cy: 'cy-gb',
    en: 'en-us',
    fil: 'fil-ph',
    'gd-gb': 'gd',
    'lo-la': 'lo',
    'mn-mn': 'mn',
    no: 'nn-no',
    or: 'or-in',
    'pa-in': 'pa',
    prs: 'prs-af',
    pt: 'pt-br',
    sr: 'sr-latn-rs',
    'sr-cyrl': 'sr-cyrl-rs',
    'ug-cn': 'ug',
    uz: 'uz-latn-uz',
    'zh-hant': 'zh-cn',
    'zh-hans': 'zh-tw',
};

export function getItemsViewLocale() {
    const owaLocale = getSupportedFallbackForLocale(store.currentLocale).locale.toLocaleLowerCase();
    return OWA_LOCALE_TO_ITEMSVIEW_LOCALE_MAP[owaLocale] || owaLocale;
}
